export default {
  'pagination': {
    'total': 200,
    'per_page': 50,
    'current_page': 1,
    'last_page': 4,
    'next_page_url': 'https://vuetable.ratiw.net/api/users?per_page=50&page=2',
    'prev_page_url': null,
    'from': 1,
    'to': 50
  },
  'data': [
    {
      'id': 1,
      'name': 'Noelia O\'Kon',
      'nickname': 'asperiores',
      'email': 'otho.smitham@example.com',
      'birthdate': '1978-06-28 00:00:00',
      'gender': 'F',
      'salary': '13098.00',
      'group_id': 2,
      'created_at': '2017-01-01 07:21:10',
      'updated_at': '2017-01-01 07:21:10',
      'age': 38,
      'group': {
        'id': 2,
        'name': 'Exec',
        'description': 'Executives'
      },
      'address': {
        'id': 1,
        'user_id': 1,
        'line1': '0888 Aniyah Locks\nLake Bridie, NJ 51086',
        'line2': 'Cayman Islands',
        'zipcode': '92991-2805',
        'mobile': '1-742-816-9238x848',
        'fax': '(484)438-4697x8638'
      }
    },
    {
      'id': 2,
      'name': 'Mr. Enid Von PhD',
      'nickname': 'alias',
      'email': 'pollich.cecilia@example.com',
      'birthdate': '1990-09-18 00:00:00',
      'gender': 'M',
      'salary': '35978.00',
      'group_id': 4,
      'created_at': '2017-01-01 07:21:10',
      'updated_at': '2017-01-01 07:21:10',
      'age': 26,
      'group': {
        'id': 4,
        'name': 'Sup',
        'description': 'Supervisors'
      },
      'address': {
        'id': 2,
        'user_id': 2,
        'line1': '59732 Iva Spur Suite 468\nEast Hortenseton, VA 70087',
        'line2': 'Cayman Islands',
        'zipcode': '41967',
        'mobile': '1-913-407-7558x503',
        'fax': '(388)906-8002'
      }
    },
    {
      'id': 3,
      'name': 'Colton Koch',
      'nickname': 'id',
      'email': 'little.myrna@example.net',
      'birthdate': '1968-10-29 00:00:00',
      'gender': 'F',
      'salary': '26278.00',
      'group_id': 3,
      'created_at': '2017-01-01 07:21:10',
      'updated_at': '2017-01-01 07:21:10',
      'age': 48,
      'group': {
        'id': 3,
        'name': 'Mgr',
        'description': 'Managers'
      },
      'address': {
        'id': 3,
        'user_id': 3,
        'line1': '539 Conn Locks Suite 801\nTobinfort, IL 37047-5508',
        'line2': 'Antigua and Barbuda',
        'zipcode': '51722-4502',
        'mobile': '557.845.1830x844',
        'fax': '1-831-304-7444x73027'
      }
    },
    {
      'id': 4,
      'name': 'Gregory Vandervort',
      'nickname': 'vel',
      'email': 'dock47@example.org',
      'birthdate': '1989-12-12 00:00:00',
      'gender': 'M',
      'salary': '25537.00',
      'group_id': 3,
      'created_at': '2017-01-01 07:21:10',
      'updated_at': '2017-01-01 07:21:10',
      'age': 27,
      'group': {
        'id': 3,
        'name': 'Mgr',
        'description': 'Managers'
      },
      'address': {
        'id': 4,
        'user_id': 4,
        'line1': '916 Rosemary Forge\nKreigerton, MT 24207',
        'line2': 'Uganda',
        'zipcode': '67639-6707',
        'mobile': '766.431.9121',
        'fax': '(154)336-3674x08451'
      }
    },
    {
      'id': 5,
      'name': 'Miss Rahsaan Heaney IV',
      'nickname': 'qui',
      'email': 'ugrady@example.org',
      'birthdate': '1995-11-27 00:00:00',
      'gender': 'F',
      'salary': '49003.00',
      'group_id': 2,
      'created_at': '2017-01-01 07:21:10',
      'updated_at': '2017-01-01 07:21:10',
      'age': 21,
      'group': {
        'id': 2,
        'name': 'Exec',
        'description': 'Executives'
      },
      'address': {
        'id': 5,
        'user_id': 5,
        'line1': '91792 Kertzmann Prairie Apt. 376\nLake Nakiaville, DC 98189',
        'line2': 'Jamaica',
        'zipcode': '10101-1450',
        'mobile': '07507519787',
        'fax': '+24(9)5120507985'
      }
    },
    {
      'id': 6,
      'name': 'Ms. Crystel Zemlak IV',
      'nickname': 'reiciendis',
      'email': 'amari.rau@example.com',
      'birthdate': '1968-09-12 00:00:00',
      'gender': 'F',
      'salary': '12383.00',
      'group_id': 4,
      'created_at': '2017-01-01 07:21:10',
      'updated_at': '2017-01-01 07:21:10',
      'age': 48,
      'group': {
        'id': 4,
        'name': 'Sup',
        'description': 'Supervisors'
      },
      'address': {
        'id': 6,
        'user_id': 6,
        'line1': '97650 Scot Haven Apt. 160\nCrawfordmouth, ME 39767-7003',
        'line2': 'Finland',
        'zipcode': '88917',
        'mobile': '1-851-069-9234x9566',
        'fax': '(048)445-4691x33356'
      }
    },
    {
      'id': 7,
      'name': 'Nona McDermott',
      'nickname': 'quaerat',
      'email': 'adrien.baumbach@example.org',
      'birthdate': '1985-10-01 00:00:00',
      'gender': 'F',
      'salary': '18512.00',
      'group_id': 4,
      'created_at': '2017-01-01 07:21:10',
      'updated_at': '2017-01-01 07:21:10',
      'age': 31,
      'group': {
        'id': 4,
        'name': 'Sup',
        'description': 'Supervisors'
      },
      'address': {
        'id': 7,
        'user_id': 7,
        'line1': '4332 Alvina Radial\nPort Darbyville, IA 63357',
        'line2': 'Barbados',
        'zipcode': '79679',
        'mobile': '(736)058-1324',
        'fax': '002.234.8466x49816'
      }
    },
    {
      'id': 8,
      'name': 'Miss Genoveva Murazik V',
      'nickname': 'rerum',
      'email': 'ohettinger@example.net',
      'birthdate': '1988-10-19 00:00:00',
      'gender': 'F',
      'salary': '31209.00',
      'group_id': 2,
      'created_at': '2017-01-01 07:21:10',
      'updated_at': '2017-01-01 07:21:10',
      'age': 28,
      'group': {
        'id': 2,
        'name': 'Exec',
        'description': 'Executives'
      },
      'address': {
        'id': 8,
        'user_id': 8,
        'line1': '96418 Ritchie Mall Apt. 215\nLake Jessyca, VT 65970-8256',
        'line2': 'Netherlands Antilles',
        'zipcode': '94649-6628',
        'mobile': '472.825.7183',
        'fax': '400-507-7463'
      }
    },
    {
      'id': 9,
      'name': 'Beulah Huels',
      'nickname': 'non',
      'email': 'stefan99@example.com',
      'birthdate': '1963-09-04 00:00:00',
      'gender': 'F',
      'salary': '36920.00',
      'group_id': 5,
      'created_at': '2017-01-01 07:21:10',
      'updated_at': '2017-01-01 07:21:10',
      'age': 53,
      'group': {
        'id': 5,
        'name': 'Emp',
        'description': 'Employees'
      },
      'address': {
        'id': 9,
        'user_id': 9,
        'line1': '18890 Carroll Lakes Suite 355\nUptonchester, UT 94878-0739',
        'line2': 'Hong Kong',
        'zipcode': '91204',
        'mobile': '831.652.0832',
        'fax': '(688)788-8947'
      }
    },
    {
      'id': 10,
      'name': 'Zoe Klein',
      'nickname': 'ex',
      'email': 'ejacobson@example.org',
      'birthdate': '1990-04-19 00:00:00',
      'gender': 'F',
      'salary': '35616.00',
      'group_id': 3,
      'created_at': '2017-01-01 07:21:10',
      'updated_at': '2017-01-01 07:21:10',
      'age': 27,
      'group': {
        'id': 3,
        'name': 'Mgr',
        'description': 'Managers'
      },
      'address': {
        'id': 10,
        'user_id': 10,
        'line1': '6721 Nader Summit\nLake Alana, MS 84476',
        'line2': 'Reunion',
        'zipcode': '77124-1459',
        'mobile': '1-129-438-6148',
        'fax': '(913)441-3846'
      }
    },
    {
      'id': 11,
      'name': 'Vickie Kiehn',
      'nickname': 'assumenda',
      'email': 'ayost@example.com',
      'birthdate': '1988-04-20 00:00:00',
      'gender': 'F',
      'salary': '30790.00',
      'group_id': 3,
      'created_at': '2017-01-01 07:21:10',
      'updated_at': '2017-01-01 07:21:10',
      'age': 29,
      'group': {
        'id': 3,
        'name': 'Mgr',
        'description': 'Managers'
      },
      'address': {
        'id': 11,
        'user_id': 11,
        'line1': '763 McCullough Ville\nNew Thomasstad, HI 64611',
        'line2': 'Oman',
        'zipcode': '00642',
        'mobile': '1-296-172-2126x275',
        'fax': '(559)203-8694'
      }
    },
    {
      'id': 12,
      'name': 'Elwyn Herzog',
      'nickname': 'praesentium',
      'email': 'ckassulke@example.net',
      'birthdate': '1990-01-22 00:00:00',
      'gender': 'M',
      'salary': '35785.00',
      'group_id': 1,
      'created_at': '2017-01-01 07:21:10',
      'updated_at': '2017-01-01 07:21:10',
      'age': 27,
      'group': {
        'id': 1,
        'name': 'Admin',
        'description': 'Administrators'
      },
      'address': {
        'id': 12,
        'user_id': 12,
        'line1': '65641 Baron Spurs Suite 988\nNorth Ivah, IA 92235',
        'line2': 'Nepal',
        'zipcode': '90316-7411',
        'mobile': '064.482.9432x9456',
        'fax': '05936098280'
      }
    },
    {
      'id': 13,
      'name': 'Selena Hettinger',
      'nickname': 'et',
      'email': 'bashirian.hyman@example.net',
      'birthdate': '1981-10-01 00:00:00',
      'gender': 'F',
      'salary': '31836.00',
      'group_id': 5,
      'created_at': '2017-01-01 07:21:10',
      'updated_at': '2017-01-01 07:21:10',
      'age': 35,
      'group': {
        'id': 5,
        'name': 'Emp',
        'description': 'Employees'
      },
      'address': {
        'id': 13,
        'user_id': 13,
        'line1': '42272 Stoltenberg Points Suite 006\nLake Dustin, NH 70213-2043',
        'line2': 'Uganda',
        'zipcode': '60996-2982',
        'mobile': '(508)122-5892',
        'fax': '356-682-2023x07379'
      }
    },
    {
      'id': 14,
      'name': 'Edwin Beier',
      'nickname': 'eos',
      'email': 'janis71@example.org',
      'birthdate': '1978-10-13 00:00:00',
      'gender': 'M',
      'salary': '11902.00',
      'group_id': 1,
      'created_at': '2017-01-01 07:21:10',
      'updated_at': '2017-01-01 07:21:10',
      'age': 38,
      'group': {
        'id': 1,
        'name': 'Admin',
        'description': 'Administrators'
      },
      'address': {
        'id': 14,
        'user_id': 14,
        'line1': '362 Trantow Loop Apt. 150\nLake Marafurt, DC 27926',
        'line2': 'Gabon',
        'zipcode': '36943-1099',
        'mobile': '033-386-4972x26066',
        'fax': '1-363-037-1381'
      }
    },
    {
      'id': 15,
      'name': 'Lexi Braun MD',
      'nickname': 'autem',
      'email': 'dusty74@example.net',
      'birthdate': '1971-12-07 00:00:00',
      'gender': 'F',
      'salary': '11927.00',
      'group_id': 4,
      'created_at': '2017-01-01 07:21:10',
      'updated_at': '2017-01-01 07:21:10',
      'age': 45,
      'group': {
        'id': 4,
        'name': 'Sup',
        'description': 'Supervisors'
      },
      'address': {
        'id': 15,
        'user_id': 15,
        'line1': '6737 Schimmel Crossing Suite 720\nShieldsberg, AK 44558',
        'line2': 'Tanzania',
        'zipcode': '75615',
        'mobile': '338.920.3112',
        'fax': '(467)912-6668'
      }
    },
    {
      'id': 16,
      'name': 'Jovany Spencer',
      'nickname': 'fugit',
      'email': 'gbogisich@example.org',
      'birthdate': '1974-04-23 00:00:00',
      'gender': 'F',
      'salary': '44686.00',
      'group_id': 3,
      'created_at': '2017-01-01 07:21:10',
      'updated_at': '2017-01-01 07:21:10',
      'age': 43,
      'group': {
        'id': 3,
        'name': 'Mgr',
        'description': 'Managers'
      },
      'address': {
        'id': 16,
        'user_id': 16,
        'line1': '97237 Emory Mission\nWelchview, DE 65827-8746',
        'line2': 'Turkmenistan',
        'zipcode': '17948',
        'mobile': '(163)991-1609x963',
        'fax': '104.893.7648'
      }
    },
    {
      'id': 17,
      'name': 'Prof. Maci Anderson DVM',
      'nickname': 'dolorem',
      'email': 'btorp@example.com',
      'birthdate': '1988-03-30 00:00:00',
      'gender': 'M',
      'salary': '25055.00',
      'group_id': 1,
      'created_at': '2017-01-01 07:21:10',
      'updated_at': '2017-01-01 07:21:10',
      'age': 29,
      'group': {
        'id': 1,
        'name': 'Admin',
        'description': 'Administrators'
      },
      'address': {
        'id': 17,
        'user_id': 17,
        'line1': '7584 Lucinda Mill\nNew Kaitlyn, WV 63380-4289',
        'line2': 'Gibraltar',
        'zipcode': '51150-2800',
        'mobile': '(977)115-7349',
        'fax': '652-788-4860x1180'
      }
    },
    {
      'id': 18,
      'name': 'Joel Kulas MD',
      'nickname': 'sed',
      'email': 'phoebe.sauer@example.org',
      'birthdate': '1992-10-26 00:00:00',
      'gender': 'F',
      'salary': '11650.00',
      'group_id': 3,
      'created_at': '2017-01-01 07:21:10',
      'updated_at': '2017-01-01 07:21:10',
      'age': 24,
      'group': {
        'id': 3,
        'name': 'Mgr',
        'description': 'Managers'
      },
      'address': {
        'id': 18,
        'user_id': 18,
        'line1': '992 Williamson Passage Apt. 910\nBradleyborough, MO 93100-9439',
        'line2': 'Cambodia',
        'zipcode': '20591-3066',
        'mobile': '+64(7)3402369877',
        'fax': '08960801902'
      }
    },
    {
      'id': 19,
      'name': 'Mr. Dawson Greenholt',
      'nickname': 'nostrum',
      'email': 'asawayn@example.org',
      'birthdate': '1963-08-23 00:00:00',
      'gender': 'F',
      'salary': '46962.00',
      'group_id': 4,
      'created_at': '2017-01-01 07:21:10',
      'updated_at': '2017-01-01 07:21:10',
      'age': 53,
      'group': {
        'id': 4,
        'name': 'Sup',
        'description': 'Supervisors'
      },
      'address': {
        'id': 19,
        'user_id': 19,
        'line1': '8444 Abraham Isle\nEast Chaunceychester, HI 78625-4417',
        'line2': 'Qatar',
        'zipcode': '47870-8012',
        'mobile': '797-274-3187x45557',
        'fax': '(461)432-8205'
      }
    },
    {
      'id': 20,
      'name': 'Prof. Lloyd Green',
      'nickname': 'velit',
      'email': 'laila.hintz@example.org',
      'birthdate': '1970-10-31 00:00:00',
      'gender': 'M',
      'salary': '12928.00',
      'group_id': 3,
      'created_at': '2017-01-01 07:21:10',
      'updated_at': '2017-01-01 07:21:10',
      'age': 46,
      'group': {
        'id': 3,
        'name': 'Mgr',
        'description': 'Managers'
      },
      'address': {
        'id': 20,
        'user_id': 20,
        'line1': '89766 O\'Connell Falls\nSouth Kadenshire, NJ 78754-6650',
        'line2': 'Nigeria',
        'zipcode': '37859',
        'mobile': '1-457-536-1138',
        'fax': '+98(5)0101745942'
      }
    },
    {
      'id': 21,
      'name': 'Shayna Morar',
      'nickname': 'rerum',
      'email': 'wfay@example.org',
      'birthdate': '1991-01-24 00:00:00',
      'gender': 'F',
      'salary': '22638.00',
      'group_id': 5,
      'created_at': '2017-01-01 07:21:10',
      'updated_at': '2017-01-01 07:21:10',
      'age': 26,
      'group': {
        'id': 5,
        'name': 'Emp',
        'description': 'Employees'
      },
      'address': {
        'id': 21,
        'user_id': 21,
        'line1': '6066 Weissnat Run Apt. 578\nMurazikmouth, SD 62877-3174',
        'line2': 'Brunei Darussalam',
        'zipcode': '69261',
        'mobile': '(487)423-0151x5127',
        'fax': '784-058-9197'
      }
    },
    {
      'id': 22,
      'name': 'Krista Schulist',
      'nickname': 'qui',
      'email': 'gregoria.jakubowski@example.com',
      'birthdate': '1974-08-16 00:00:00',
      'gender': 'F',
      'salary': '49345.00',
      'group_id': 2,
      'created_at': '2017-01-01 07:21:10',
      'updated_at': '2017-01-01 07:21:10',
      'age': 42,
      'group': {
        'id': 2,
        'name': 'Exec',
        'description': 'Executives'
      },
      'address': {
        'id': 22,
        'user_id': 22,
        'line1': '331 Gerlach Course Suite 090\nKovacekchester, RI 18017',
        'line2': 'Sri Lanka',
        'zipcode': '37165',
        'mobile': '653-487-3061x91119',
        'fax': '370-709-1750'
      }
    },
    {
      'id': 23,
      'name': 'Leone Lemke',
      'nickname': 'repellat',
      'email': 'ltorphy@example.com',
      'birthdate': '1975-06-27 00:00:00',
      'gender': 'M',
      'salary': '17560.00',
      'group_id': 5,
      'created_at': '2017-01-01 07:21:10',
      'updated_at': '2017-01-01 07:21:10',
      'age': 41,
      'group': {
        'id': 5,
        'name': 'Emp',
        'description': 'Employees'
      },
      'address': {
        'id': 23,
        'user_id': 23,
        'line1': '4371 Ward Village Suite 848\nLake Madalynton, IN 44643',
        'line2': 'Ukraine',
        'zipcode': '71848',
        'mobile': '174-502-0881x50649',
        'fax': '02683328099'
      }
    },
    {
      'id': 24,
      'name': 'Dr. Willie Kemmer II',
      'nickname': 'quasi',
      'email': 'ivy51@example.net',
      'birthdate': '1987-04-06 00:00:00',
      'gender': 'F',
      'salary': '35370.00',
      'group_id': 4,
      'created_at': '2017-01-01 07:21:10',
      'updated_at': '2017-01-01 07:21:10',
      'age': 30,
      'group': {
        'id': 4,
        'name': 'Sup',
        'description': 'Supervisors'
      },
      'address': {
        'id': 24,
        'user_id': 24,
        'line1': '235 Hassie Mountain\nAnikaborough, ID 20678-4354',
        'line2': 'Thailand',
        'zipcode': '94264-9132',
        'mobile': '624.042.8382x12243',
        'fax': '274.716.7226x171'
      }
    },
    {
      'id': 25,
      'name': 'Deonte Lebsack',
      'nickname': 'nesciunt',
      'email': 'alisa83@example.net',
      'birthdate': '1993-01-26 00:00:00',
      'gender': 'M',
      'salary': '32725.00',
      'group_id': 4,
      'created_at': '2017-01-01 07:21:10',
      'updated_at': '2017-01-01 07:21:10',
      'age': 24,
      'group': {
        'id': 4,
        'name': 'Sup',
        'description': 'Supervisors'
      },
      'address': {
        'id': 25,
        'user_id': 25,
        'line1': '793 Lakin Haven\nLake Citlalliborough, DE 85031-4862',
        'line2': 'Chad',
        'zipcode': '52396-8822',
        'mobile': '(950)170-8013',
        'fax': '119.675.5485x79062'
      }
    },
    {
      'id': 26,
      'name': 'Prof. Shayne Nader',
      'nickname': 'voluptas',
      'email': 'bosco.shaina@example.net',
      'birthdate': '1993-10-26 00:00:00',
      'gender': 'F',
      'salary': '9844.00',
      'group_id': 5,
      'created_at': '2017-01-01 07:21:10',
      'updated_at': '2017-01-01 07:21:10',
      'age': 23,
      'group': {
        'id': 5,
        'name': 'Emp',
        'description': 'Employees'
      },
      'address': {
        'id': 26,
        'user_id': 26,
        'line1': '0330 Smith Mountains\nLorinetown, NY 96547-9723',
        'line2': 'Syrian Arab Republic',
        'zipcode': '85415',
        'mobile': '1-212-704-6685',
        'fax': '516-893-8515'
      }
    },
    {
      'id': 27,
      'name': 'Prof. Kennith Kertzmann',
      'nickname': 'alias',
      'email': 'satterfield.jonathan@example.com',
      'birthdate': '1992-01-31 00:00:00',
      'gender': 'F',
      'salary': '41950.00',
      'group_id': 1,
      'created_at': '2017-01-01 07:21:10',
      'updated_at': '2017-01-01 07:21:10',
      'age': 25,
      'group': {
        'id': 1,
        'name': 'Admin',
        'description': 'Administrators'
      },
      'address': {
        'id': 27,
        'user_id': 27,
        'line1': '901 Hauck Extensions\nKeaganborough, VA 47392',
        'line2': 'Comoros',
        'zipcode': '54147-7615',
        'mobile': '1-274-179-2031x915',
        'fax': '867-583-0812x6728'
      }
    },
    {
      'id': 28,
      'name': 'Miss Meagan O\'Keefe',
      'nickname': 'corporis',
      'email': 'tracy.barrows@example.com',
      'birthdate': '1967-05-04 00:00:00',
      'gender': 'M',
      'salary': '41803.00',
      'group_id': 1,
      'created_at': '2017-01-01 07:21:10',
      'updated_at': '2017-01-01 07:21:10',
      'age': 50,
      'group': {
        'id': 1,
        'name': 'Admin',
        'description': 'Administrators'
      },
      'address': {
        'id': 28,
        'user_id': 28,
        'line1': '29077 Avis Isle Apt. 208\nGrahamberg, MI 62485-6694',
        'line2': 'Cocos (Keeling) Islands',
        'zipcode': '56090-7671',
        'mobile': '(718)856-9319x55184',
        'fax': '(777)055-4685x56167'
      }
    },
    {
      'id': 29,
      'name': 'Prof. Edward Pagac MD',
      'nickname': 'quia',
      'email': 'gerhard65@example.org',
      'birthdate': '1973-09-22 00:00:00',
      'gender': 'F',
      'salary': '22896.00',
      'group_id': 5,
      'created_at': '2017-01-01 07:21:10',
      'updated_at': '2017-01-01 07:21:10',
      'age': 43,
      'group': {
        'id': 5,
        'name': 'Emp',
        'description': 'Employees'
      },
      'address': {
        'id': 29,
        'user_id': 29,
        'line1': '697 Crona Mall\nPeteville, WA 54497',
        'line2': 'Saudi Arabia',
        'zipcode': '07560-8569',
        'mobile': '788-579-8208',
        'fax': '041-521-9215'
      }
    },
    {
      'id': 30,
      'name': 'Samantha Weissnat',
      'nickname': 'est',
      'email': 'crystel66@example.net',
      'birthdate': '1974-07-11 00:00:00',
      'gender': 'M',
      'salary': '18805.00',
      'group_id': 5,
      'created_at': '2017-01-01 07:21:10',
      'updated_at': '2017-01-01 07:21:10',
      'age': 42,
      'group': {
        'id': 5,
        'name': 'Emp',
        'description': 'Employees'
      },
      'address': {
        'id': 30,
        'user_id': 30,
        'line1': '79984 Deckow Run\nEast Victoria, UT 33736',
        'line2': 'Lithuania',
        'zipcode': '95964-8864',
        'mobile': '681.200.3099',
        'fax': '(567)652-4322x61475'
      }
    },
    {
      'id': 31,
      'name': 'Dr. Gilbert Ward',
      'nickname': 'dolorum',
      'email': 'sandrine06@example.net',
      'birthdate': '1984-08-22 00:00:00',
      'gender': 'F',
      'salary': '16644.00',
      'group_id': 1,
      'created_at': '2017-01-01 07:21:10',
      'updated_at': '2017-01-01 07:21:10',
      'age': 32,
      'group': {
        'id': 1,
        'name': 'Admin',
        'description': 'Administrators'
      },
      'address': {
        'id': 31,
        'user_id': 31,
        'line1': '996 Schuppe Glen\nTurcottetown, ID 40821-7190',
        'line2': 'Thailand',
        'zipcode': '09965-7576',
        'mobile': '1-938-263-0257x47178',
        'fax': '1-997-727-3198x4363'
      }
    },
    {
      'id': 32,
      'name': 'Mike West',
      'nickname': 'laudantium',
      'email': 'jborer@example.net',
      'birthdate': '1974-11-07 00:00:00',
      'gender': 'M',
      'salary': '35728.00',
      'group_id': 3,
      'created_at': '2017-01-01 07:21:10',
      'updated_at': '2017-01-01 07:21:10',
      'age': 42,
      'group': {
        'id': 3,
        'name': 'Mgr',
        'description': 'Managers'
      },
      'address': {
        'id': 32,
        'user_id': 32,
        'line1': '69942 Leannon Glen\nEast Mathilde, IL 89584-5633',
        'line2': 'Afghanistan',
        'zipcode': '02041-8706',
        'mobile': '(506)349-9443x7244',
        'fax': '1-357-689-8479x3729'
      }
    },
    {
      'id': 33,
      'name': 'Prof. Isabell Cruickshank I',
      'nickname': 'recusandae',
      'email': 'ondricka.lurline@example.org',
      'birthdate': '1982-06-15 00:00:00',
      'gender': 'F',
      'salary': '44574.00',
      'group_id': 2,
      'created_at': '2017-01-01 07:21:10',
      'updated_at': '2017-01-01 07:21:10',
      'age': 34,
      'group': {
        'id': 2,
        'name': 'Exec',
        'description': 'Executives'
      },
      'address': {
        'id': 33,
        'user_id': 33,
        'line1': '875 Logan Summit Suite 033\nJerodport, NY 45166',
        'line2': 'Kiribati',
        'zipcode': '64763',
        'mobile': '1-548-943-8405x460',
        'fax': '+88(4)9493664736'
      }
    },
    {
      'id': 34,
      'name': 'Prof. Lonny Rath',
      'nickname': 'nihil',
      'email': 'rfeest@example.net',
      'birthdate': '1969-04-23 00:00:00',
      'gender': 'F',
      'salary': '19949.00',
      'group_id': 5,
      'created_at': '2017-01-01 07:21:10',
      'updated_at': '2017-01-01 07:21:10',
      'age': 48,
      'group': {
        'id': 5,
        'name': 'Emp',
        'description': 'Employees'
      },
      'address': {
        'id': 34,
        'user_id': 34,
        'line1': '43006 Gaylord Drives\nCummerataville, MA 14032-6378',
        'line2': 'Georgia',
        'zipcode': '88459',
        'mobile': '(877)526-6771',
        'fax': '(724)630-5418'
      }
    },
    {
      'id': 35,
      'name': 'Santina Medhurst MD',
      'nickname': 'suscipit',
      'email': 'ila24@example.net',
      'birthdate': '1965-11-04 00:00:00',
      'gender': 'F',
      'salary': '36323.00',
      'group_id': 1,
      'created_at': '2017-01-01 07:21:10',
      'updated_at': '2017-01-01 07:21:10',
      'age': 51,
      'group': {
        'id': 1,
        'name': 'Admin',
        'description': 'Administrators'
      },
      'address': {
        'id': 35,
        'user_id': 35,
        'line1': '47345 Imelda Mission Suite 257\nAllyshire, IA 85430-2783',
        'line2': 'Gambia',
        'zipcode': '26853',
        'mobile': '(441)229-8922',
        'fax': '(789)908-0620x15912'
      }
    },
    {
      'id': 36,
      'name': 'Jeff Lehner',
      'nickname': 'quo',
      'email': 'jarred77@example.com',
      'birthdate': '1975-05-18 00:00:00',
      'gender': 'F',
      'salary': '48462.00',
      'group_id': 1,
      'created_at': '2017-01-01 07:21:10',
      'updated_at': '2017-01-01 07:21:10',
      'age': 41,
      'group': {
        'id': 1,
        'name': 'Admin',
        'description': 'Administrators'
      },
      'address': {
        'id': 36,
        'user_id': 36,
        'line1': '49133 Tremaine Cape Suite 189\nQuitzonview, SC 07967-6920',
        'line2': 'Serbia',
        'zipcode': '96642',
        'mobile': '313.254.8635x06428',
        'fax': '194.681.7297x74202'
      }
    },
    {
      'id': 37,
      'name': 'Samanta Pfeffer',
      'nickname': 'officia',
      'email': 'fgoyette@example.net',
      'birthdate': '1974-08-27 00:00:00',
      'gender': 'F',
      'salary': '19601.00',
      'group_id': 4,
      'created_at': '2017-01-01 07:21:10',
      'updated_at': '2017-01-01 07:21:10',
      'age': 42,
      'group': {
        'id': 4,
        'name': 'Sup',
        'description': 'Supervisors'
      },
      'address': {
        'id': 37,
        'user_id': 37,
        'line1': '1313 Verdie Square\nNorth Giovanna, MI 27962',
        'line2': 'Guyana',
        'zipcode': '77776',
        'mobile': '(321)705-8910',
        'fax': '(392)460-5663x665'
      }
    },
    {
      'id': 38,
      'name': 'Ofelia Torp',
      'nickname': 'a',
      'email': 'ericka44@example.net',
      'birthdate': '1981-09-01 00:00:00',
      'gender': 'M',
      'salary': '33149.00',
      'group_id': 4,
      'created_at': '2017-01-01 07:21:10',
      'updated_at': '2017-01-01 07:21:10',
      'age': 35,
      'group': {
        'id': 4,
        'name': 'Sup',
        'description': 'Supervisors'
      },
      'address': {
        'id': 38,
        'user_id': 38,
        'line1': '45335 Albina View\nCharlottefort, AK 57789',
        'line2': 'Afghanistan',
        'zipcode': '54947-9310',
        'mobile': '09097085723',
        'fax': '1-567-446-3094'
      }
    },
    {
      'id': 39,
      'name': 'Mrs. Margarete Raynor',
      'nickname': 'quia',
      'email': 'jlegros@example.net',
      'birthdate': '1977-03-12 00:00:00',
      'gender': 'M',
      'salary': '21951.00',
      'group_id': 3,
      'created_at': '2017-01-01 07:21:10',
      'updated_at': '2017-01-01 07:21:10',
      'age': 40,
      'group': {
        'id': 3,
        'name': 'Mgr',
        'description': 'Managers'
      },
      'address': {
        'id': 39,
        'user_id': 39,
        'line1': '288 Hamill Knolls\nMaximoburgh, NC 50971',
        'line2': 'Zimbabwe',
        'zipcode': '00474',
        'mobile': '1-165-445-8956x699',
        'fax': '164-395-7526x1304'
      }
    },
    {
      'id': 40,
      'name': 'Mr. Brant Howell V',
      'nickname': 'perspiciatis',
      'email': 'franecki.gerald@example.org',
      'birthdate': '1964-03-01 00:00:00',
      'gender': 'M',
      'salary': '41552.00',
      'group_id': 3,
      'created_at': '2017-01-01 07:21:10',
      'updated_at': '2017-01-01 07:21:10',
      'age': 53,
      'group': {
        'id': 3,
        'name': 'Mgr',
        'description': 'Managers'
      },
      'address': {
        'id': 40,
        'user_id': 40,
        'line1': '3411 Deckow Crossing\nVernonport, MI 32272-8542',
        'line2': 'Bolivia',
        'zipcode': '00960',
        'mobile': '(998)729-9537',
        'fax': '(606)461-9736'
      }
    },
    {
      'id': 41,
      'name': 'Reilly Ruecker DVM',
      'nickname': 'ad',
      'email': 'ldeckow@example.net',
      'birthdate': '1975-07-17 00:00:00',
      'gender': 'M',
      'salary': '22709.00',
      'group_id': 5,
      'created_at': '2017-01-01 07:21:10',
      'updated_at': '2017-01-01 07:21:10',
      'age': 41,
      'group': {
        'id': 5,
        'name': 'Emp',
        'description': 'Employees'
      },
      'address': {
        'id': 41,
        'user_id': 41,
        'line1': '39181 Runolfsson Pines Apt. 102\nCedrickchester, MD 73430-4755',
        'line2': 'Haiti',
        'zipcode': '08208-7956',
        'mobile': '625-483-9111x773',
        'fax': '196-367-9338'
      }
    },
    {
      'id': 42,
      'name': 'Zachery McDermott',
      'nickname': 'molestiae',
      'email': 'gladyce84@example.com',
      'birthdate': '1992-04-17 00:00:00',
      'gender': 'F',
      'salary': '32354.00',
      'group_id': 2,
      'created_at': '2017-01-01 07:21:10',
      'updated_at': '2017-01-01 07:21:10',
      'age': 25,
      'group': {
        'id': 2,
        'name': 'Exec',
        'description': 'Executives'
      },
      'address': {
        'id': 42,
        'user_id': 42,
        'line1': '18735 Quigley Springs\nCarterview, NE 29126-7625',
        'line2': 'Chad',
        'zipcode': '61676-5075',
        'mobile': '172.676.4844x42744',
        'fax': '129.383.7365x233'
      }
    },
    {
      'id': 43,
      'name': 'Heloise Kulas',
      'nickname': 'aut',
      'email': 'kessler.helen@example.net',
      'birthdate': '1962-12-11 00:00:00',
      'gender': 'M',
      'salary': '45086.00',
      'group_id': 5,
      'created_at': '2017-01-01 07:21:10',
      'updated_at': '2017-01-01 07:21:10',
      'age': 54,
      'group': {
        'id': 5,
        'name': 'Emp',
        'description': 'Employees'
      },
      'address': {
        'id': 43,
        'user_id': 43,
        'line1': '38208 Dolores Turnpike Apt. 887\nWintheiserton, FL 72054-2578',
        'line2': 'Lithuania',
        'zipcode': '51634-6449',
        'mobile': '1-161-626-3235x57765',
        'fax': '360-278-9045x9316'
      }
    },
    {
      'id': 44,
      'name': 'Norma Dibbert',
      'nickname': 'amet',
      'email': 'eudora36@example.net',
      'birthdate': '1971-01-21 00:00:00',
      'gender': 'F',
      'salary': '15661.00',
      'group_id': 1,
      'created_at': '2017-01-01 07:21:10',
      'updated_at': '2017-01-01 07:21:10',
      'age': 46,
      'group': {
        'id': 1,
        'name': 'Admin',
        'description': 'Administrators'
      },
      'address': {
        'id': 44,
        'user_id': 44,
        'line1': '15405 Haag Haven Suite 047\nBrakusland, WV 81778',
        'line2': 'British Virgin Islands',
        'zipcode': '56087-0885',
        'mobile': '08227730599',
        'fax': '1-079-566-2337x670'
      }
    },
    {
      'id': 45,
      'name': 'Immanuel Auer',
      'nickname': 'quia',
      'email': 'halvorson.theodora@example.org',
      'birthdate': '1978-06-06 00:00:00',
      'gender': 'M',
      'salary': '15862.00',
      'group_id': 3,
      'created_at': '2017-01-01 07:21:10',
      'updated_at': '2017-01-01 07:21:10',
      'age': 38,
      'group': {
        'id': 3,
        'name': 'Mgr',
        'description': 'Managers'
      },
      'address': {
        'id': 45,
        'user_id': 45,
        'line1': '59888 Dare Ridge\nSouth Annamaeton, CA 94659',
        'line2': 'Mexico',
        'zipcode': '56689-3824',
        'mobile': '523.579.8757x9825',
        'fax': '688.695.5156x073'
      }
    },
    {
      'id': 46,
      'name': 'Lamont Borer',
      'nickname': 'expedita',
      'email': 'trantow.neoma@example.com',
      'birthdate': '1992-06-26 00:00:00',
      'gender': 'M',
      'salary': '12544.00',
      'group_id': 1,
      'created_at': '2017-01-01 07:21:10',
      'updated_at': '2017-01-01 07:21:10',
      'age': 24,
      'group': {
        'id': 1,
        'name': 'Admin',
        'description': 'Administrators'
      },
      'address': {
        'id': 46,
        'user_id': 46,
        'line1': '974 Brannon Circle Suite 674\nSchroedermouth, NM 66911',
        'line2': 'Malawi',
        'zipcode': '74027',
        'mobile': '887.196.2530x875',
        'fax': '220.398.6969'
      }
    },
    {
      'id': 47,
      'name': 'Brooke Purdy',
      'nickname': 'cupiditate',
      'email': 'bhermiston@example.net',
      'birthdate': '1966-11-19 00:00:00',
      'gender': 'M',
      'salary': '14457.00',
      'group_id': 4,
      'created_at': '2017-01-01 07:21:10',
      'updated_at': '2017-01-01 07:21:10',
      'age': 50,
      'group': {
        'id': 4,
        'name': 'Sup',
        'description': 'Supervisors'
      },
      'address': {
        'id': 47,
        'user_id': 47,
        'line1': '916 Durgan Harbor\nWest Tonyborough, MN 08368',
        'line2': 'Serbia',
        'zipcode': '25234',
        'mobile': '(821)777-8137x4048',
        'fax': '(398)917-7496x84537'
      }
    },
    {
      'id': 48,
      'name': 'Dr. Leo Dach',
      'nickname': 'et',
      'email': 'camila.ward@example.com',
      'birthdate': '1968-01-11 00:00:00',
      'gender': 'F',
      'salary': '40278.00',
      'group_id': 2,
      'created_at': '2017-01-01 07:21:10',
      'updated_at': '2017-01-01 07:21:10',
      'age': 49,
      'group': {
        'id': 2,
        'name': 'Exec',
        'description': 'Executives'
      },
      'address': {
        'id': 48,
        'user_id': 48,
        'line1': '434 Dariana Terrace\nSouth Brettbury, NC 66080-2445',
        'line2': 'Latvia',
        'zipcode': '81749-2523',
        'mobile': '1-988-628-9566x4627',
        'fax': '916.932.2071x569'
      }
    },
    {
      'id': 49,
      'name': 'Krystal Langosh',
      'nickname': 'voluptatum',
      'email': 'pacocha.yesenia@example.org',
      'birthdate': '1983-02-18 00:00:00',
      'gender': 'M',
      'salary': '9305.00',
      'group_id': 2,
      'created_at': '2017-01-01 07:21:10',
      'updated_at': '2017-01-01 07:21:10',
      'age': 34,
      'group': {
        'id': 2,
        'name': 'Exec',
        'description': 'Executives'
      },
      'address': {
        'id': 49,
        'user_id': 49,
        'line1': '012 Josiane Flats Suite 650\nKatelynntown, MD 70053',
        'line2': 'Rwanda',
        'zipcode': '75946-8166',
        'mobile': '(556)620-0323x81232',
        'fax': '1-466-040-3197x6274'
      }
    },
    {
      'id': 50,
      'name': 'Florence Greenfelder',
      'nickname': 'odit',
      'email': 'kenyatta.oconnell@example.com',
      'birthdate': '1978-08-20 00:00:00',
      'gender': 'F',
      'salary': '36980.00',
      'group_id': 1,
      'created_at': '2017-01-01 07:21:10',
      'updated_at': '2017-01-01 07:21:10',
      'age': 38,
      'group': {
        'id': 1,
        'name': 'Admin',
        'description': 'Administrators'
      },
      'address': {
        'id': 50,
        'user_id': 50,
        'line1': '295 Donna Plaza Apt. 186\nHintzview, GA 44706',
        'line2': 'Greenland',
        'zipcode': '03127',
        'mobile': '1-044-098-3635x9446',
        'fax': '1-753-472-6796'
      }
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/anaassays/vuestic-datatable/data/local-data.js